// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"fCmEV":[function(require,module,exports) {
require("9242a7734204f9a6").register(require("83808fbdf887db0").getBundleURL('hwWrm'), JSON.parse("[\"hwWrm\",\"iframe.face88a3.js\",\"39pRY\",\"Illustrations.7e31fb39.js\",\"dT3aN\",\"Illustrations.08e5b693.js\",\"l97GQ\",\"Illustrations.8ef9a402.js\",\"WaANz\",\"Illustrations.146e599d.css\",\"55Jkm\",\"Illustrations.611ab1c5.js\",\"bMhQw\",\"Illustrations.8124dfa3.js\",\"eHfoC\",\"Illustrations.d173ab38.js\",\"SMq0d\",\"Illustrations.9acac5bf.js\",\"j1xEi\",\"Illustrations.fc4927a2.css\",\"2nfmz\",\"Illustrations.14dbba32.js\",\"iCntD\",\"Illustrations.ee9c5014.css\",\"i9w28\",\"Illustrations.674e2895.js\",\"4FYQ3\",\"Illustrations.84d31e87.css\",\"9ARUd\",\"Intro.240dfce7.js\",\"houWz\",\"wallpaper_collaborative_S2_desktop.1ae295a9.webp\",\"1T4Tb\",\"Intro.5316f73b.css\",\"bN0dZ\",\"Migrating.8b4a161d.js\",\"mNrzu\",\"Migrating.300d5573.css\",\"6JyDN\",\"Release Notes.e8d42c84.js\",\"fmPNL\",\"Release Notes.2ca32584.css\",\"2XzIv\",\"Style Macro.859e556d.js\",\"47Xno\",\"Style Macro.1869a6d6.css\",\"7Hoor\",\"Workflow Icons.7f6927fe.js\",\"bB2kH\",\"Workflow Icons.a074f265.css\",\"eLGT7\",\"Accordion.stories.9885892d.js\",\"aj6nj\",\"Accordion.stories.53ce8771.css\",\"9kObJ\",\"ActionButton.stories.b88602c8.js\",\"8Hsfh\",\"ActionButton.stories.88bb43e5.css\",\"3e6mC\",\"ActionMenu.stories.a808fe19.js\",\"8YEKX\",\"ActionMenu.stories.0ee73426.css\",\"fZfyU\",\"AlertDialog.stories.162eab45.js\",\"a3oNQ\",\"AlertDialog.stories.955e7f0a.css\",\"iyO8H\",\"Avatar.stories.87a12b37.js\",\"gRpfF\",\"Avatar.stories.d27a4518.css\",\"1aOpP\",\"AvatarGroup.stories.7300dd81.js\",\"jyhq5\",\"AvatarGroup.stories.d9f686f8.css\",\"cfGPo\",\"Badge.stories.db027184.js\",\"dcMMO\",\"Badge.stories.38841264.css\",\"eUpIl\",\"Breadcrumbs.stories.e568687f.js\",\"l3OGB\",\"Breadcrumbs.stories.264c430d.css\",\"64vA5\",\"Button.stories.b199e3dc.js\",\"fodKL\",\"Button.stories.69160e31.css\",\"et3Lq\",\"ButtonGroup.stories.c39b37f3.js\",\"gi3ow\",\"ButtonGroup.stories.526db2da.css\",\"folB3\",\"Card.stories.bcd2792b.js\",\"jCMyB\",\"preview.fa2965aa.png\",\"qFmOx\",\"placeholder.f0db36ef.png\",\"gKqlt\",\"Card.stories.673c2111.css\",\"aF3vH\",\"CardView.stories.a8978379.js\",\"2OyP6\",\"CardView.stories.b9730ad4.css\",\"b9l3s\",\"Checkbox.stories.b2e0a9d7.js\",\"inhoG\",\"Checkbox.stories.1f465dc8.css\",\"5NY87\",\"CheckboxGroup.stories.71966321.js\",\"72gYR\",\"CheckboxGroup.stories.c5a327df.css\",\"5UsQo\",\"ColorArea.stories.d411f260.js\",\"c8nKp\",\"ColorArea.stories.3903a1f5.css\",\"7Pkqb\",\"ColorField.stories.c9e90ef1.js\",\"lAGw4\",\"ColorField.stories.62761ca1.css\",\"auQQi\",\"ColorSlider.stories.df30e718.js\",\"jE2aW\",\"ColorSlider.stories.a3357d9e.css\",\"KfCuN\",\"ColorSwatch.stories.cb48f971.js\",\"a4mDN\",\"ColorSwatch.stories.5b0539ef.css\",\"1SHhE\",\"ColorSwatchPicker.stories.3aecc377.js\",\"8FXZX\",\"ColorSwatchPicker.stories.4e942176.css\",\"eWmjz\",\"ColorWheel.stories.67585b29.js\",\"4SFeZ\",\"ColorWheel.stories.45c208d2.css\",\"8FViP\",\"ComboBox.stories.8a5189f1.js\",\"9EggB\",\"ComboBox.stories.1b27ebb3.css\",\"2yQlC\",\"ContextualHelp.stories.84754099.js\",\"3IxdI\",\"ContextualHelp.stories.81ab0f7d.css\",\"gydEm\",\"Dialog.stories.209ca5fd.js\",\"8tqBU\",\"Dialog.stories.920fe944.css\",\"i830q\",\"Disclosure.stories.a50e395c.js\",\"c4Rcc\",\"Disclosure.stories.a2db3fdd.css\",\"gpuKu\",\"Divider.stories.759b3ba4.js\",\"hRJrl\",\"Divider.stories.cd721365.css\",\"b7AKK\",\"DropZone.stories.8cbc12ab.js\",\"5WXqr\",\"DropZone.stories.3c3b1f8d.css\",\"gvNTO\",\"Form.stories.fa1b8c1c.js\",\"5WZsw\",\"Form.stories.5f45c79d.css\",\"2J4iM\",\"Icon.stories.6c0179ef.js\",\"1Osj1\",\"Icon.stories.e75c9b9c.css\",\"2pLFX\",\"IllustratedMessage.stories.ece7b2aa.js\",\"dy86P\",\"IllustratedMessage.stories.d5d6d745.css\",\"4Jn3q\",\"InlineAlert.stories.4540b7d9.js\",\"2CDox\",\"InlineAlert.stories.13ac07de.css\",\"l6338\",\"Link.stories.e32f149a.js\",\"i6tIA\",\"Link.stories.eca8d947.css\",\"4o8rv\",\"LinkButton.stories.8926dcf3.js\",\"i1z4E\",\"LinkButton.stories.bb2cec81.css\",\"5aKWo\",\"Menu.stories.498cd9c6.js\",\"3dz4g\",\"normal.ded32008.png\",\"i5AJT\",\"multiply.9c18c7f4.png\",\"bOxzc\",\"screen.88c89678.png\",\"l44QX\",\"Menu.stories.6adf51d7.css\",\"bMEHB\",\"Meter.stories.0da8c3b3.js\",\"XhAKv\",\"Meter.stories.631dcd07.css\",\"f32Et\",\"NumberField.stories.4d6508ab.js\",\"fnxPW\",\"NumberField.stories.b70b898b.css\",\"dIPQS\",\"Picker.stories.77bfa103.js\",\"e68Ue\",\"Picker.stories.74e95ad1.css\",\"diYJz\",\"ProgressBar.stories.bdde0547.js\",\"dTmPb\",\"ProgressBar.stories.77e2dee6.css\",\"5fPZ0\",\"ProgressCircle.stories.8c3beadb.js\",\"lHAlH\",\"ProgressCircle.stories.eeac5057.css\",\"erJSa\",\"RadioGroup.stories.8d953d83.js\",\"9AWD7\",\"RadioGroup.stories.349bf210.css\",\"9ZSFC\",\"RangeSlider.stories.42143053.js\",\"24PhJ\",\"RangeSlider.stories.cfb1c0fe.css\",\"aYqJn\",\"SearchField.stories.dd1957ab.js\",\"5ywx8\",\"SearchField.stories.e803b0bf.css\",\"bOvoM\",\"SegmentedControl.stories.ca907d16.js\",\"jFFjh\",\"SegmentedControl.stories.51d44984.css\",\"48qJ5\",\"Slider.stories.d8abf37d.js\",\"ehIh9\",\"Slider.stories.f2631dd4.css\",\"5mOO2\",\"StatusLight.stories.76c1f175.js\",\"hdqAI\",\"StatusLight.stories.f34649c9.css\",\"1J62s\",\"StyleMacro.stories.2a817938.js\",\"aH1DI\",\"StyleMacro.stories.4cf86c3f.css\",\"4uSsF\",\"Switch.stories.fd4585de.js\",\"bFscJ\",\"Switch.stories.9dbb9a1b.css\",\"5qlzg\",\"TableView.stories.8dfa26c6.js\",\"3Kj9V\",\"TableView.stories.25df41ac.css\",\"a9wjm\",\"Tabs.stories.b1304e78.js\",\"9RFWd\",\"Tabs.stories.01089b25.css\",\"lhw4f\",\"TagGroup.stories.deb12593.js\",\"5etcV\",\"TagGroup.stories.89e2003a.css\",\"jrEXW\",\"TextField.stories.0a3178a4.js\",\"hk0Hn\",\"TextField.stories.fc42fa98.css\",\"5fCaH\",\"ToggleButton.stories.4596f8cc.js\",\"6Qvzn\",\"ToggleButton.stories.1c075613.css\",\"7YkCD\",\"Tooltip.stories.bc20aece.js\",\"aaEGr\",\"Tooltip.stories.74cc9d9f.css\",\"6ImEy\",\"entry-preview.b85ea4ee.js\",\"7T47R\",\"entry-preview-docs.b0dd6388.js\",\"3iNPV\",\"entry-preview-docs.849965fa.js\",\"1ZwWP\",\"preview.c14dc633.js\",\"drIJM\",\"preview.2bf13b26.js\",\"k2xzB\",\"react.70f1f1eb.js\",\"6TqEJ\",\"preview.bbd9a367.js\",\"554s6\",\"Color-6VNJS4EI.561d086a.js\",\"hVqbS\",\"syntaxhighlighter-B5GMVT5T.56672b31.js\",\"5i9jI\",\"formatter-SWP5E3XI.75e4cca4.js\",\"6yEHs\",\"WithTooltip-V3YHNWJZ.474e138c.js\",\"5GOFz\",\"preview.21ae5b4c.js\",\"gtT8W\",\"preview.832a51b1.js\",\"6qAEA\",\"preview.12895fbd.js\",\"lmtzC\",\"preview.ccae316b.js\",\"emh3v\",\"preview.0de03500.js\",\"4R7E1\",\"preview.3b85922a.js\",\"gzSo2\",\"preview.7760943e.js\",\"jaO8Q\",\"axe.cac72621.js\",\"4jtly\",\"preview.6da2bfd2.js\",\"bTHCn\",\"logo.5ec3ca99.svg\",\"bJnNC\",\"logo-dark.bdeff35f.svg\",\"6xLq8\",\"preview.46bf1497.css\"]"));

},{"9242a7734204f9a6":"kK08P","83808fbdf887db0":"kMf2L"}],"kK08P":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"kMf2L":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["fCmEV"], null, "parcelRequire94c2")

//# sourceMappingURL=iframe.runtime.2846d302.js.map
